import React from 'react';

import { Draggable } from 'react-beautiful-dnd';
import { Fleet } from '../priority-configuration';
import { Translations as FleetsTranslations } from './fleets';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

const getItemStyle = (isDragging, draggableStyle) => ({
	userSelect: 'none',
	...draggableStyle
});

interface Props {
	fleet: Fleet;
	index: number;
	isDragDisabled?: boolean;
	translations?: FleetsTranslations;
}

const DraggableFleet: React.FC<Props> = ({ fleet, index, isDragDisabled, translations }) => {
	const isGreen = fleet?.capabilities?.is_green;

	return (
		<Draggable draggableId={fleet.id} index={index} isDragDisabled={isDragDisabled}>
			{(provided, snapshot) => (
				<div
					className="fleet-group fake-grid-row"
					ref={provided.innerRef}
					{...provided.draggableProps}
					style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
				>
					<span className="drag-icon" {...provided.dragHandleProps}>
						<BringgIcon iconName={BringgFontIcons.Drag} />
					</span>
					<span className="fleet-name">
						{fleet.fleet_type === 33 ? translations.internalFleetName || fleet.name : fleet.name}
						{isGreen && (
							<BringgIcon iconName={BringgFontIcons.LeafEco} className="green-fleet-icon-container" />
						)}
					</span>
				</div>
			)}
		</Draggable>
	);
};

export default DraggableFleet;
